// extracted by mini-css-extract-plugin
export default {"footer":"joshua_footer__3R4g0","footerLink":"joshua_footerLink__xG1Cn"};